const PUBLIC_ASSET_BASE =
  typeof process !== "undefined" && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : "";

export const SOUND_PACK_STORAGE_KEY = "rv-sound-pack";
export const SOUND_PACK_SYNC_EVENT = "rv-sound-pack-sync";
export const DEFAULT_SOUND_PACK = "male";

export const SOUND_PACK_FOLDERS = {
  male: "male",
  female: "female",
  "sounds-only": "soundsonly",
};

export const SOUND_EVENTS = {
  INCIDENT_CREATED: "incident-created",
  INCIDENT_UPDATED: "incident-updated",
  INCIDENT_CLEARED: "incident-cleared",
  DISPATCH_ASSIGNED: "dispatch-assigned",
  GPS_ENABLED: "gps-enabled",
  GPS_DISABLED: "gps-disabled",
  STATUS_CHECK_REQUIRED: "status-check-required",
  STATUS_UPDATED: "status-updated",
  WELCOME: "welcome",
};

const SOUND_EVENT_FILES = {
  [SOUND_EVENTS.INCIDENT_CREATED]: "incidentcreated.wav",
  [SOUND_EVENTS.INCIDENT_UPDATED]: "incidentupdated.wav",
  [SOUND_EVENTS.INCIDENT_CLEARED]: "incidentcleared.wav",
  [SOUND_EVENTS.DISPATCH_ASSIGNED]: "newdispatch.wav",
  [SOUND_EVENTS.GPS_ENABLED]: "gpsenabled.mp3",
  [SOUND_EVENTS.GPS_DISABLED]: "gpsdisabled.mp3",
  [SOUND_EVENTS.STATUS_CHECK_REQUIRED]: "statuscheckrequired.wav",
  [SOUND_EVENTS.STATUS_UPDATED]: "statusupdated.wav",
  [SOUND_EVENTS.WELCOME]: "welcome.mp3",
};

export function resolveSoundPack(value) {
  if (!value || typeof value !== "string") {
    return DEFAULT_SOUND_PACK;
  }
  const normalized = value.trim().toLowerCase();
  if (normalized === "no-audio") {
    return "no-audio";
  }
  if (Object.prototype.hasOwnProperty.call(SOUND_PACK_FOLDERS, normalized)) {
    return normalized;
  }
  return DEFAULT_SOUND_PACK;
}

export function getSoundCuePath(pack, eventKey) {
  const folder = Object.prototype.hasOwnProperty.call(SOUND_PACK_FOLDERS, pack)
    ? SOUND_PACK_FOLDERS[pack]
    : null;
  const file = Object.prototype.hasOwnProperty.call(SOUND_EVENT_FILES, eventKey)
    ? SOUND_EVENT_FILES[eventKey]
    : null;
  if (!folder || !file) {
    return null;
  }
  if (pack === "sounds-only") {
    return eventKey === SOUND_EVENTS.STATUS_CHECK_REQUIRED
      ? `${PUBLIC_ASSET_BASE}/sounds/statuscheckalarm.mp3`
      : `${PUBLIC_ASSET_BASE}/sounds/soundsonly/notification.wav`;
  }
  return `${PUBLIC_ASSET_BASE}/sounds/${folder}/${file}`;
}

export function getEmergencySoundPath() {
  return `${PUBLIC_ASSET_BASE}/sounds/emergency.mp3`;
}

export function getUrgentOverridePack(pack) {
  if (pack && pack !== "no-audio") {
    return pack;
  }
  return DEFAULT_SOUND_PACK;
}
